import { LegalLayout, LegalSection } from "../components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="June 2026" testid="terms-page">
      <p>
        These Terms of Service ("Terms") govern your use of RoadRnr ("RoadRnr",
        "we", "us"), an automotive event discovery app and website (the "Service").
        By using the Service you agree to these Terms. If you do not agree, please
        do not use the Service.
      </p>

      <LegalSection heading="Using the Service">
        <p>
          RoadRnr helps you discover automotive events such as car meets, shows,
          track days and drives, and lets organisers list their own events. You agree
          to use the Service lawfully and not to misuse, disrupt or attempt to gain
          unauthorised access to it.
        </p>
      </LegalSection>

      <LegalSection heading="Accounts">
        <p>
          Some features require an account. You are responsible for providing
          accurate information, for keeping your login details secure, and for
          activity that happens under your account. Let us know if you believe your
          account has been used without your permission.
        </p>
      </LegalSection>

      <LegalSection heading="Event discovery">
        <p>
          Event information on RoadRnr is provided for general discovery and may be
          submitted by organisers or the community. Details can change or be
          inaccurate. You are responsible for checking event details — including
          dates, times, location, entry requirements and tickets — directly with the
          organiser before travelling or making plans.
        </p>
      </LegalSection>

      <LegalSection heading="Organiser listings & content">
        <p>If you submit or list an event, you confirm that:</p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>The information you provide is accurate and kept up to date.</li>
          <li>
            You own or have the rights to the content and images you submit, and their
            use on RoadRnr does not infringe anyone else's rights.
          </li>
          <li>
            You grant RoadRnr a non-exclusive licence to display, reproduce and
            promote your listing and its images within the Service.
          </li>
        </ul>
        <p>You remain responsible for the content of your listings.</p>
      </LegalSection>

      <LegalSection heading="Prohibited content">
        <p>You must not submit content that is:</p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>illegal, or that promotes illegal or unsafe activity;</li>
          <li>false, misleading or fraudulent;</li>
          <li>infringing on intellectual property or other rights;</li>
          <li>offensive, abusive, or otherwise inappropriate; or</li>
          <li>spam or unsolicited promotion.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Moderation">
        <p>
          We review submitted events and may, at our discretion, edit, hide, reject
          or remove any listing or content — for example if it appears inaccurate,
          inappropriate, or in breach of these Terms — with or without notice.
        </p>
      </LegalSection>

      <LegalSection heading="Paid listings & Boost">
        <p>
          Organisers receive a number of free event listings each month. Additional
          listing credits and promotional Boost/Featured placement are available as
          paid features. Any current prices, credit amounts and what each feature
          includes are shown in the app at the time of purchase. Payments are
          processed securely by Stripe.
        </p>
        <p>
          If you have a problem with a purchase, contact us at{" "}
          <a href="mailto:roadrnrapp@gmail.com" className="font-semibold text-[#ff2a00]">
            roadrnrapp@gmail.com
          </a>{" "}
          and we will try to help. Your statutory rights are not affected.
        </p>
      </LegalSection>

      <LegalSection heading="Third-party links">
        <p>
          Listings may include links to third-party websites, ticketing providers and
          social media. We do not control and are not responsible for third-party
          sites, their content, or any tickets or services you obtain through them.
          Those services are subject to their own terms.
        </p>
      </LegalSection>

      <LegalSection heading="Availability & changes">
        <p>
          We aim to keep the Service available but do not guarantee it will be
          uninterrupted or error-free. We may change, suspend or discontinue features
          at any time.
        </p>
      </LegalSection>

      <LegalSection heading="Disclaimer & liability">
        <p>
          The Service and its event information are provided "as is" and "as
          available", without warranties of any kind. To the fullest extent permitted
          by law, RoadRnr is not liable for the accuracy of event listings, for
          third-party content or services, or for any indirect or consequential loss
          arising from your use of the Service or attendance at any event. Nothing in
          these Terms limits liability that cannot be limited under applicable law.
        </p>
      </LegalSection>

      <LegalSection heading="Changes to these Terms">
        <p>
          We may update these Terms from time to time. When we do, we will update the
          date at the top of this page. Continued use of the Service means you accept
          the updated Terms.
        </p>
      </LegalSection>

      <LegalSection heading="Removal of content & advertising">
        <p>
          RoadRnr may hide or remove events, banner ads or other content that is
          unsuitable, inaccurate or breaks our rules. Content removed for a breach may
          not qualify for a refund, and event listing credits are not restored,
          subject to applicable law.
        </p>
        <p>
          Advertisers are responsible for their content, their rights to it, its
          accuracy, the destination links, and compliance with the RoadRnr Banner Ad
          Rules. Nothing here affects your statutory rights.
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>
          Questions about these Terms? Email us at{" "}
          <a href="mailto:roadrnrapp@gmail.com" className="font-semibold text-[#ff2a00]">
            roadrnrapp@gmail.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
